import React from 'react'

export function HomeSkeletonPromotion(props) {
    const {
        position
    } = props

	return(
		<>
            <section className={`sectionIcos homePosition${position}`}>
                <div className="container">
                    <div className="promotionA1 skeleton">
                        <div className="img bones" width="655" height="368"/>
                        <div className="img bones" width="655" height="368"/>
                        <div className="img bones" width="655" height="368"/>
                    </div>
                </div>
            </section>
		</>
	);
}

export default React.memo(HomeSkeletonPromotion)